import { getRequiredFields } from 'utils/form'

const fields = [
  {
    label: 'Write a note',
    name: 'comments',
    layout: 'fullWidth',
    maxLength: 400,
    validators: [
      {
        check: 'required',
      },
    ],
    error: 'Please enter a note',
  },
  {
    label: '',
    name: 'previousComments',
    layout: 'fullWidth',
    maxLength: 2000,
    validators: [],
    error: '',
  },
]

export const requiredFields = getRequiredFields(fields)
export const formFields = fields
export default formFields



// WEBPACK FOOTER //
// ./src/schemas/forms/BeneficiaryComment.js